import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useInputStyles = createUseStyles({
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& > input': {
      minHeight: 40
    },
    '& > label': {
      fontWeight: 'bold',
      color: colors.gray600,
      fontSize: 12,
      margin: '0.5rem 0'
    }
  }
})

export { useInputStyles }
